import { Beenhere, CircleNotifications, Domain, Groups, HowToReg, MenuBook } from "@mui/icons-material"
import SettingsIcon from '@mui/icons-material/Settings'
import { Tab, Tabs } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { Fragment, useContext, useState } from "react"
import CondominiosConfig from "./CondominiosConfig/CondominiosConfig"
import EquipesConfig from "./EquipesConfig/EquipesConfig"
import EventosConfig from "./EventosConfig/EventosConfig"
import FechamentoConfig from "./FechamentoConfig/FechamentoConfig"
import TagsConfig from "./TagsConfig/TagsConfig"
import UsuariosConfig from "./UsuariosConfig/UsuariosConfig"
import GlobalConfig from "./GlobalConfig/GlobalConfig"
import { UserContext } from "../../Providers/UserContext/UserContex"

const tabsOptions = [
    {
        label: "Condomínios / Empresas",
        componente: CondominiosConfig,
        icon: Domain
    },
    {
        label: "Eventos",
        componente: EventosConfig,
        icon: CircleNotifications
    },
    {
        label: "Texto Fechamento",
        componente: FechamentoConfig,
        icon: MenuBook
    },
    {
        label: "Tag",
        componente: TagsConfig,
        icon: Beenhere
    },
    {
        label: "Usuários",
        componente: UsuariosConfig,
        icon: HowToReg
    },
    {
        label: "Equipes",
        componente: EquipesConfig,
        icon: Groups
    },
    {
        label: "Conf. Gerais",
        componente: GlobalConfig,
        icon: SettingsIcon
    }
]

const ConfiguracoesPage = () => {
    const [tabIndex, setTabIndex] = useState(0)
    const { user } = useContext(UserContext)

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex)
    }

    return (
        <Grid sx={{ width: '100%', height: '100%', padding: '10px', display: 'flex', flexFlow: 'column' }}>
            <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                variant="fullWidth"
                sx={{
                    flexGrow: 0,
                    flexBasis: 'auto',
                    padding: 0,
                    margin: 0,
                    // borderBottom: '1px solid white',
                    height: '35px',
                    minHeight: '35px',
                    color: "#fff",
                    '& .MuiTabs-indicator': { display: 'none' },
                    '& .MuiTab-root': {
                        padding: 1,
                        margin: 0,
                        minHeight: '35px',
                        height: '35px',
                        color: "#fff !important",
                        borderBottom: '1px solid #fff',
                        fontSize: '0.8vmax',
                        fontWeight: 700
                    },
                    '& .Mui-selected': {
                        color: "#fff",
                        borderLeft: 'white solid 0.5px',
                        borderRight: 'white solid 0.5px',
                        borderTop: 'white solid 0.5px',
                        borderBottom: '0px',
                        borderRadius: '5px 5px 0 0',
                        padding: 1,
                        margin: 0
                    }
                }}
            >
                {tabsOptions.map((tab) => {
                    if (tab.label == "Configurações Gerais") {
                        if (user.nivel < 3) {
                            return (
                                <Tab
                                    key={tab.label}
                                    icon={<tab.icon/>}
                                    iconPosition="start"
                                    label={tab.label}
                                />
                            )
                        }
                    } else {
                        return (
                            <Tab
                                key={tab.label}
                                icon={<tab.icon/>}
                                iconPosition="start"
                                label={tab.label}
                            />
                        )
                    }
                })}
            </Tabs>

            <Grid container sx={{ paddingTop: '10px', display: 'flex', flexBasis: 'auto', flexGrow: 1, overflowY: 'hidden' }}>
                {tabsOptions.map((tab, index) => {
                    return (
                        <Fragment key={index}>
                            {tabIndex === index &&
                                <tab.componente key={tab.label}/>
                            }
                        </Fragment>
                    )
                })}
            </Grid>

        </Grid>
    )
}

export default ConfiguracoesPage
